import { isEmpty, type ProgramData, type TaskType, TaskTypeSchema, type UnsavedProgramTask } from '@terros/common'
import { setTaskPriority } from './util'
import { type FormProgramTask, type FormTaskType, type TaskFormResult } from './types'
import { fromFormExpiration } from './expiration'
import { fromFormDuration, timeToMinutes } from './duration'

export const fromTaskFormValues = (values: FormProgramTask, program: ProgramData): TaskFormResult => {
  const updatedTask = fromFormTask(values)
  const updatedTasks = values.programTaskId
    ? program.tasks.map((t) => (t.programTaskId === values.programTaskId ? updatedTask : t))
    : [...program.tasks, updatedTask]
  return {
    tasks: setTaskPriority(updatedTasks),
    changedTaskIndex: values.programTaskId
      ? program.tasks.findIndex((t) => t.programTaskId === values.programTaskId)
      : -1,
  }
}

const fromFormTask = (values: FormProgramTask): UnsavedProgramTask => {
  const openSince = timeToMinutes(values.openSince)
  const duration = fromFormDuration(values.duration, openSince)
  const expiration = fromFormExpiration(values.expiration, duration, openSince)
  const nextTaskIds = values.nextTaskIds ?? []
  return {
    ...values,
    openSince,
    duration,
    expiration,
    type: getTaskType(values.type),
    nextTaskIds,
    nextTaskId: isEmpty(nextTaskIds) ? undefined : nextTaskIds[0],
  }
}

export const getTaskType = (formType: FormTaskType): TaskType => {
  const parse = TaskTypeSchema.safeParse(formType)
  if (parse.success) return parse.data
  switch (formType) {
    case 'CreateAccount':
    case 'PitchProspect':
    case 'SalesOutput':
    case 'SalesPlanning':
      return 'SalesActivity'
    case 'Shadowing':
      return 'SalesTraining'
    case 'WorkflowAction':
    case 'WorkflowStage':
      return 'WorkflowTasks'
    default:
      return formType
  }
}
